import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import logo from 'assets/icons/logo.svg';
import motorolaIcon from 'assets/icons/motorolaIcon.svg';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStoreSelector } from 'v3/data/store';
import { getStorePermissions } from 'v3/data/store/stores/actions';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { RoutesEnum } from 'v3/routes/enum';
import { MenuSelect } from 'v3/shared/components/Menu';
import {
  DrawerContainer,
  DrawerStyled,
  ImgStyled,
  NavigationButtons,
  NavigationGroup,
  paperStyle,
} from 'v3/shared/components/OnlineNavBar/styles';
import { SubtitleMediumBold } from 'v3/shared/typography/SubtitleMedium';

export const OnlineNavBar = () => {
  const { isDesktop } = useBreakpoints();
  const navigate = useNavigate();
  const location = useLocation();

  const { openProductList, isMaster, isGroupAdmin } = getStorePermissions();
  const [shouldEnableStoreButton, setShouldEnableStoreButton] = useState<boolean>(false);
  const shouldDisableStoreButton = !(isMaster && shouldEnableStoreButton);
  const [sellerFeatureEnabled, setSellerFeatureEnabled] = useState<boolean>(false);

  const verifyPath = (pathName: string): boolean => pathName === location.pathname;
  const { storeLogged } = useStoreSelector((store) => store.store);

  const handleButtonClick = (route: string) => {
    navigate(route);
  };

  return (
    <DrawerStyled PaperProps={paperStyle} variant={'permanent'} anchor={'top'} open={true}>
      <DrawerContainer>
        {isDesktop ? <ImgStyled alt="logo" src={logo} /> : <img src={motorolaIcon} alt="Logo da motorola" />}

        <NavigationGroup>
          <NavigationButtons onClick={() => handleButtonClick(RoutesEnum.Home)} active={verifyPath(RoutesEnum.Home)}>
            <ListAltRoundedIcon />
            {isDesktop && <SubtitleMediumBold>Contratos</SubtitleMediumBold>}
          </NavigationButtons>
        </NavigationGroup>

        <MenuSelect StartIcon={StorefrontOutlinedIcon} userName={storeLogged.name} />
      </DrawerContainer>
    </DrawerStyled>
  );
};
